// extracted by mini-css-extract-plugin
module.exports = {"ldsEllipsis1":"style-module--lds-ellipsis1--1wSte","ldsEllipsis3":"style-module--lds-ellipsis3--1l5CE","ldsEllipsis2":"style-module--lds-ellipsis2--2_h5b"};